export default __webpack_public_path__ + "static/media/466.dc5b07db.png";